import React, { useState, useEffect, useRef } from "react";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import Categories from "../data/categories.json";
import Projects from "../data/projects.json";

gsap.registerPlugin(ScrollTrigger);

const Portfolio = () => {
  const elementRef = useRef(null);
  const [filteredProjects, setFilteredProjects] = useState(Projects);
  const [currentCategory, setCurrentCategory] = useState("All");
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 6;

  const totalPages = Math.ceil(filteredProjects.length / itemsPerPage);
  const currentItems = filteredProjects.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  useEffect(() => {
    gsap.fromTo(
      elementRef.current,
      { opacity: 0, y: 50 },
      {
        opacity: 1,
        y: 0,
        duration: 1,
        ease: "power2.out",
        scrollTrigger: {
          trigger: elementRef.current,
          start: "top 80%",
          toggleActions: "play none none reverse",
        },
      }
    );
  }, []);

  useEffect(() => {
    gsap.fromTo(
      ".project-item",
      { opacity: 0, y: 20 },
      { opacity: 1, y: 0, duration: 0.5, stagger: 0.2, ease: "power2.out" }
    );
  }, [currentItems]);

  const handleFilter = (category) => {
    setCurrentCategory(category);
    setCurrentPage(1);
    if (category === "All") {
      setFilteredProjects(Projects);
    } else {
      setFilteredProjects(
        Projects.filter((project) => project.category === category)
      );
    }
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  return (
    <section id="portfolio" className="projects-area">
      <div className="container">
        <div className="row">
          <div className="col-xl-12 col-lg-12">
            <div ref={elementRef} style={{ opacity: 0 }}>
              <div className="section-title text-center wow fadeInUp delay-0-2s">
                <p>Works</p>
                <h2>Creative Portfolio</h2>
              </div>
            </div>
          </div>
        </div>
        <ul className="project-filter filter-btns-one justify-content-left pb-15 wow fadeInUp delay-0-2s">
          {Categories.map((category) => (
            <li
              key={category.id}
              className={`filter-btn ${category.className} ${
                currentCategory === category.name ? "current" : ""
              }`}
              onClick={() => handleFilter(category.name)}
            >
              {category.name}
            </li>
          ))}
        </ul>
        <div className="row project-masonry-active">
          {currentItems.length > 0 ? (
            currentItems.map((project) => (
              <div
                key={project.id}
                className="col-lg-4 col-md-6 item project-item"
              >
                <div className="project-item style-two">
                  <div className="project-image">
                    <img src={project.image} alt={project.name} />
                    <a
                      href={project.link}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="details-btn work-popup project-link"
                    >
                      <i className="ri-arrow-right-up-line"></i>
                    </a>
                  </div>
                  <div className="project-content">
                    <span className="sub-title text-uppercase project-category">
                      {project.category}
                    </span>
                    <h3 className="project-name">{project.name}</h3>
                  </div>
                </div>
              </div>
            ))
          ) : (
            <div className="col-12 text-center no-results d-flex align-items-center justify-content-center">
              <p>No Results for [<strong>{currentCategory}</strong>]</p>
            </div>
          )}
        </div>
        <div className="pagination">
          {Array.from({ length: totalPages }, (_, index) => (
            <button
              key={index}
              className={`page-btn ${currentPage === index + 1 ? "active" : ""}`}
              onClick={() => handlePageChange(index + 1)}
            >
              {index + 1}
            </button>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Portfolio;
